/* tslint:disable */
/* This is generated by ts_routes-rails */

export type ScalarType = string | number | boolean;

function $buildOptions(options: any, names: string[]): string {
  if (options) {
    let anchor = "";
    const q = [] as string[];
    for (const key of Object.keys(options)) {
      if (names.indexOf(key) !== -1) {
        // the key is already consumed
        continue;
      }

      const value = options[key];

      if (key === "anchor") {
        anchor = `#${$encode(value)}`;
      } else {
        $buildQuery(q, key, value);
      }
    }
    return (q.length > 0 ? "?" + q.join("&") : "") + anchor;
  } else {
    return "";
  }
}

function $buildQuery(q: string[], key: string, value: any) {
  if ($isScalarType(value)) {
    q.push(`${$encode(key)}=${$encode(value)}`);
  } else if (Array.isArray(value)) {
    for (const v of value) {
      $buildQuery(q, `${key}[]`, v);
    }
  } else if (value != null) {
    // i.e. non-null, non-scalar, non-array type
    for (const k of Object.keys(value)) {
      $buildQuery(q, `${key}[${k}]`, value[k]);
    }
  }
}

function $encode(value: any): string {
  return encodeURIComponent(value);
}

function $isScalarType(value: any): value is ScalarType {
  return (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  );
}

function $isPresent(value: any): boolean {
  return value != null && ("" + value).length > 0;
}

function $hasPresentOwnProperty(options: any, key: string): boolean {
  return options && options.hasOwnProperty(key) && $isPresent(options[key]);
}

/** /api/v1/auth/:provider(.:format) */
export function apiV1AuthPath(provider: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "auth" + "/" + provider + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["provider","format"]);
}

/** /api/v1/auth/:provider/callback(.:format) */
export function apiV1AuthCallbackPath(provider: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "auth" + "/" + provider + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["provider","format"]);
}

/** /api/v1/auth/failure(.:format) */
export function apiV1AuthFailurePath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "auth" + "/" + "failure" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/sessions/omniauth(.:format) */
export function omniauthApiV1SessionsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "sessions" + "/" + "omniauth" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/sessions/failure(.:format) */
export function failureApiV1SessionsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "sessions" + "/" + "failure" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/sessions(.:format) */
export function apiV1SessionsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "sessions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/current_user/mcps/:mcp_id/rules/batch_update(.:format) */
export function batchUpdateApiV1CurrentUserMCPRulesPath(mcp_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "current_user" + "/" + "mcps" + "/" + mcp_id + "/" + "rules" + "/" + "batch_update" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["mcp_id","format"]);
}

/** /api/v1/current_user/mcps(.:format) */
export function apiV1CurrentUserMcpsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "current_user" + "/" + "mcps" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/current_user/mcps/:id(.:format) */
export function apiV1CurrentUserMCPPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "current_user" + "/" + "mcps" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/current_user/rules(.:format) */
export function apiV1CurrentUserRulesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "current_user" + "/" + "rules" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/current_user/rules/:id(.:format) */
export function apiV1CurrentUserRulePath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "current_user" + "/" + "rules" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/current_user(.:format) */
export function apiV1CurrentUserPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "current_user" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users/confirm(.:format) */
export function confirmApiV1UsersPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + "/" + "confirm" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/users(.:format) */
export function apiV1UsersPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/rules(.:format) */
export function apiV1RulesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "rules" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /docs */
export function oasRailsPath(options?: object): string {
  return "/" + "docs" + $buildOptions(options, []);
}

/** /letter_opener */
export function letterOpenerWebPath(options?: object): string {
  return "/" + "letter_opener" + $buildOptions(options, []);
}

/** /letter_opener/ */
export function letterOpenerWebLettersPath(options?: object): string {
  return "/" + "letter_opener" + "/" + $buildOptions(options, []);
}

/** /letter_opener/clear(.:format) */
export function letterOpenerWebClearLettersPath(options?: object): string {
  return "/" + "letter_opener" + "/" + "clear" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /letter_opener/:id(/:style)(.:format) */
export function letterOpenerWebLetterPath(id: ScalarType, options?: object): string {
  return "/" + "letter_opener" + "/" + id + ($hasPresentOwnProperty(options, "style") ? "/" + (options as any).style : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","style","format"]);
}

/** /letter_opener/:id/delete(.:format) */
export function letterOpenerWebDeleteLetterPath(id: ScalarType, options?: object): string {
  return "/" + "letter_opener" + "/" + id + "/" + "delete" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /sidekiq */
export function sidekiqWebPath(options?: object): string {
  return "/" + "sidekiq" + $buildOptions(options, []);
}

/** / */
export function rootPath(options?: object): string {
  return "/" + $buildOptions(options, []);
}
